import { Link } from '@trussworks/react-uswds';
import Icon from '@components/icon/Icon';
import { mdiAlertCircleOutline } from '@mdi/js';

const AdditionalInfoLink = ({ request, onOpenAdditionalInfo }) => {
  if (!request || !request?.hasOpenAdditionalInfoRequest) return null;

  const handleClick = (e) => {
    e.preventDefault();
    if (onOpenAdditionalInfo) {
      onOpenAdditionalInfo({
        requestID: request?.requestID,
        version: request?.version,
        ormAdditionalInfoActionID: request?.ormAdditionalInfoActionID,
        permission: request?.permission,
        projectName: request?.projectName,
      });
    }
  };

  return (
    <div className='additional-info-link'>
      <Icon path={mdiAlertCircleOutline} size={0.85} className='margin-right-1 text-warning' />
      <Link href='' onClick={handleClick}>
        Info Required
      </Link>
    </div>
  );
};

export default AdditionalInfoLink;
